import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useAppLayout } from '@core/contexts/LayoutContext';
import { usePageMeta } from '@core/hooks/usePageMeta';
import type { PageMetaProps } from '@core/interfaces';
import PageFilter, { type PageFilterConfig } from './PageFilter';
import PageHeader from './PageHeader';
import { type PageSearchConfig } from './PageSearch';
import PageShell from './PageShell';

type PageProps = PageMetaProps & {
  action?: ReactNode;
  searchConfig?: PageSearchConfig;
  filterConfig?: PageFilterConfig;
  children: ReactNode;
  error?: string | null;
  onErrorDismiss?: () => void;
};

const Page: React.FC<PageProps> = (props) => {
  const { isWebTwo } = useAppLayout();
  const { title, subtitle } = usePageMeta(props);
  const {
    action,
    searchConfig,
    filterConfig,
    children,
    error,
    onErrorDismiss,
  } = props;

  const filter = filterConfig ? (
    <PageFilter {...filterConfig} size={isWebTwo ? 'sm' : 'md'} />
  ) : null;
  const headerAction =
    filter && action ? (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {filter}
        {action}
      </Box>
    ) : (
      (filter ?? action)
    );

  return (
    <PageShell
      header={
        <PageHeader
          title={title}
          subtitle={subtitle}
          action={headerAction}
          searchConfig={searchConfig}
        />
      }
      error={error}
      onErrorDismiss={onErrorDismiss}
    >
      {children}
    </PageShell>
  );
};

export default Page;
